module.exports = __webpack_public_path__ + "gallery-v2.img.empty-icons.dark.f0d685b6d8c05616292e1417d3bba123.svg";